import { Alert, Platform } from "react-native";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import * as Notifications from 'expo-notifications';
import * as Device from 'expo-device';
import i18n from "i18n-js";
import * as Linking from 'expo-linking';
import Constants from 'expo-constants';
import { updateNotify } from "@/stores/mainSlice";
import { NotificationContentInput, NotificationTriggerInput,TimeIntervalTriggerInput, DateTriggerInput } from "expo-notifications"
import { handleNotificationData } from "@/containers/navigation";

/**
 * Method for scheduling expo-notifications
 * @param {NotificationContentInput} content
 * @param {NotificationTriggerInput} trigger
 * @returns {Promise<string>}
 */
export async function schedulePushNotification(content, trigger) {
    const notificationId = await Notifications.scheduleNotificationAsync({
        content: {...content, sound: "default"},
        trigger: trigger,
    });
    console.ina('NTFY SET', Date.now(), notificationId, content, trigger)
    return notificationId
}

/**
 * creates a time interval trigger
 * @param {number} seconds
 * @returns {TimeIntervalTriggerInput}
 */
export function createTimeIntervalTrigger(seconds){
    return {
        type: Notifications.SchedulableTriggerInputTypes.TIME_INTERVAL,
        seconds: seconds
    }
}

/**
 * creates a date trigger
 * @param {Date} date
 * @returns {DateTriggerInput}
 */
export function createDateTrigger(date){
    return {
        type: Notifications.SchedulableTriggerInputTypes.DATE,
        date: date
    }
}

/**
 * cancels a push notification
 * @param {string} ntfyId
 * @returns {Promise<void>}
 */
export async function cancelPushNotification(ntfyId) {
    await Notifications.cancelScheduledNotificationAsync(ntfyId)
    console.ina('NTFY CAN', Date.now(), ntfyId)
}

export const Notify = (props) => {

  const dispatch = useDispatch()
  const active = useSelector((state) => state.notify?.active || []) //TODO alte Leiche?
  const [token, setToken] = useState();

  useEffect(() => {
    if (token) {
      console.ina('NTFY TOK', Date.now(), token)
      dispatch(updateNotify({ notify: { push_token: token } }))
    }
    }, [token]);


  useEffect(() => {

    registerForPushNotificationsAsync().then(token => {
      setToken(token)
    })

    const backgroundListener = Notifications.addNotificationResponseReceivedListener(response => {
        let url = response.notification.request?.content?.data?.url;
        if (!url) {
            url = response.notification.request?.trigger?.payload?.url;
        }
        console.ina('APP RESP', url);
        // Any custom logic to see whether the URL needs to be handled
        if (url) {
            Linking.openURL(url) // Let React Navigation handle the URL
            return
        }
        const data = response.notification.request?.content?.data?.nav ?? response.notification.request.trigger?.payload?.nav
        if (data){
            handleNotificationData(data, 'tap')
        }
    });

    const foregroundListener = Notifications.addNotificationReceivedListener(notification => {
        let url = notification.request?.content?.data?.url;
        if (!url) {
            url = notification.request?.trigger?.payload?.url;
        }
        console.ina('APP RESP', url);
        // Any custom logic to see whether the URL needs to be handled
        if (url) {
            if(url.startsWith("inacoach:////notify/ShowStep/")){
                console.log("Case timer foreground")
                return // foreground timer is handled by app, otherwise its to unprecise!!
            }
            Linking.openURL(url) // Let React Navigation handle the URL
        }

        /** @type{NavigationData} */
        const data = notification.request?.content?.data?.nav ?? notification.request.trigger?.payload?.nav
        console.warn("foregroundlistener data: ", data)
        if(data){
            if(data.type === "timer"){
                console.log("Case timer foreground")
                return // foreground timer is handled by app, otherwise its to unprecise!!
            }
            handleNotificationData(data, 'foreground')
        }
    })

    return () => {
        foregroundListener.remove();
        backgroundListener.remove();
    }
  }, [])

  async function registerForPushNotificationsAsync() {
    let token;

    if (Platform.OS === 'android') {
      await Notifications.setNotificationChannelAsync('default', {
        name: 'default',
        importance: Notifications.AndroidImportance.MAX,
        vibrationPattern: [0, 250, 250, 250],
        lightColor: '#FF231F7C',
      });
    }

    if (Device.isDevice) {
      const { status: existingStatus } = await Notifications.getPermissionsAsync();
      let finalStatus = existingStatus;
      if (existingStatus !== 'granted') {
        const { status } = await Notifications.requestPermissionsAsync();
        finalStatus = status;
      }
      if (finalStatus !== 'granted') {
        Alert.alert(
          i18n.t('global.info'),
          i18n.t('notify.noToken'),
          [
            {
              text: "OK",
              onPress: () => {
              },
            }
          ]
        )
        return;
      }
      if (Platform.OS === 'ios') {
        token = (await Notifications.getExpoPushTokenAsync({
          'projectId': Constants.expoConfig.extra.eas.projectId,
        })).data;
      }
    } else {
      console.log('Must use physical device for Push Notifications');
    }

    return token;
  }

  return (
    props.children
  )
}
